module.exports = __webpack_public_path__ + "media/sfx_new_msg.95baf8d6.mp3";